import React, { Component } from "react"
import styled from 'styled-components'
import { Button } from 'reactstrap'
import { get } from 'lodash'
import { FONTS } from '../../../../constants'

export default class Searchbar extends Component {
  render() {
    const editVendor = get(this.props, 'editVendor')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const canEdit = get(projectByID, '$can_edit')
    // const presale_snapshot = ge't(this.props, 'presale_snapshot')
    // const isPresale = presale_snapshot && get(this.props, 'rSelected') === 1
    // const canEdit = get(this.props, 'project.$can_edit')
    const fallbackNanOrInfinity = (number) => {
      return number === 'NaN' || number === Infinity ? '0.00' : number
    }
    const total_vendors_man_days = isPresale ? get(presale_snapshot, '$total_vendors_man_days', '-') : get(projectByID, '$total_vendors_man_days', '-')
    const total_vendors_man_days_avg = isPresale ? get(presale_snapshot, '$total_vendors_man_days_avg', '-') : get(projectByID, '$total_vendors_man_days_avg', '-')
    const total_vendors_cost = isPresale ? get(presale_snapshot, '$total_vendors_cost', '-') : get(projectByID, '$total_vendors_cost', '-')
    const total_vendors_price = isPresale ? get(presale_snapshot, '$total_vendors_price', '-') : get(projectByID, '$total_vendors_price', '-')
    const total_vendors_margin = isPresale ? fallbackNanOrInfinity(get(presale_snapshot, '$total_vendors_margin', '-')) : fallbackNanOrInfinity(get(projectByID, '$total_vendors_margin', '-'))

    const clickEdit = get(this.props, 'clickEdit')
    const cancelEdit = get(this.props, 'cancelEdit')
    const confirmEditVendor = get(this.props, 'confirmEditVendor')
    const clickAddVendor = get(this.props, 'clickAddVendor')
    return (
      <SearchDivStyle>
        <Header>
          <TextHeader>Total Man-Days</TextHeader>
          <TextNumber>{ total_vendors_man_days }</TextNumber>
          <TextHeader>Avg. Man-Day Rate</TextHeader>
          <TextNumber>{ total_vendors_man_days_avg }</TextNumber>
          <TextHeader>Total Cost (฿)</TextHeader>
          <TextNumber>{ total_vendors_cost }</TextNumber>
          <TextHeader>Total Price (฿)</TextHeader>
          <TextNumber>{ total_vendors_price }</TextNumber>
          <TextHeader>Margin (%)</TextHeader>
          <TextNumber>{ total_vendors_margin } %</TextNumber>
        </Header>
        <SearchDiv>
          {/* <SearchField
            onChange={this.props.handleSearch}
            onKeyDown={ this.props.handleSearch }
            placeholder={ 'Search By Vender Name, Code' }
          /> */}
          { !isPresale &&
            <ButtonGroup>
              { !editVendor && canEdit &&
                <CustomButton color='success' onClick={ () => clickEdit() }>Edit</CustomButton>
              }
              { editVendor &&
                <CustomButton color='success' onClick={ () => confirmEditVendor() }>Save</CustomButton>
              }
              { editVendor &&
                <CustomButton onClick={ () => cancelEdit() }>Cancel</CustomButton>
              }
              { editVendor &&
                <CustomButton color='danger' onClick={ () => clickAddVendor() }>+ Add Other Service</CustomButton>
              }
            </ButtonGroup>
          }
        </SearchDiv>
      </SearchDivStyle>
    )
  }
}
const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  margin-top: 10px;
`
const ButtonGroup = styled.div`
  text-align: right;
  margin: auto;
  margin-right: 0px !important;
  width: 50%;
`
const Header = styled.div`
  height: 60px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`
// const SearchField = styled.input`
//   background: url(${SearchIcon}) no-repeat scroll 10px 10px;
//   background-size: 20px 20px;
//   padding-left:40px;
//   font-family: 'Gotham' !important;
//   font-size: 15px;
//   width: 20%;
//   height: 40px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   margin: auto;
//   margin-left: 2% !important;
//   box-sizing: border-box;
//   -o-text-overflow: ellipsis;
//   -ms-text-overflow: ellipsis;
//   text-overflow: ellipsis;
//   ::placeholder {
//     color: #CCCCCC;
//   }
// `
const TextHeader = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  margin:auto;
  margin-right: 20px !important;
`
const TextNumber = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-left: 0% !important;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const SearchDiv = styled.div`
  height: 60px;
  padding: auto;
  display: flex;
  flex-direction: row;
`



// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-vendor-cost/index.js